import * as React from "react";
import { RouteComponentProps, withRouter, Route, Switch, Redirect } from "react-router";
import { apiAlbumToBPMAlbum } from "src/transformer";
import { AudioVideoProps, AudioVideoDefaultProps, WithToast, withToast, BPMAlbum, Loader, ListView } from 'bpm-web-generic';
import { Analytics } from "src/manager/AnalyticsManager";
import { mediaAPI } from "src/api/config";

export interface ShareProps extends AudioVideoProps, AudioVideoDefaultProps, RouteComponentProps<{ albumId: string }>, WithToast {
}
interface ShareState {
    album?: BPMAlbum
}
class ShareInner extends React.Component<ShareProps, ShareState> {

    constructor(props: ShareProps) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        this.load()
    }

    componentDidUpdate(prevProps: ShareProps) {
        if (prevProps.match.params.albumId != this.props.match.params.albumId) {
            this.load()
        }
    }


    private load() {
        mediaAPI.getAlbum(parseInt(this.props.match.params.albumId)).then(({ data: album }) => {
            this.setState({ album: apiAlbumToBPMAlbum(album) })
            Analytics.trackView('album', `${album.id}`)
        }).catch((err) => {
            this.props.showToast('warning', 'Track not found')
            window.location.assign('/')
        })
    }


    public render() {
        if (!this.state.album) {
            return <Loader />
        }
        return (
            <>
                <ListView {...this.props} context={'share'} style={{ paddingBottom: '40px' }} fluid title={this.state.album.name} contentType={'mixed'} albums={[this.state.album]}
                    hide={{ viewAll: true }} />
            </>
        )
    }
}

const SR = withToast(withRouter(ShareInner))
export const Share = withRouter(class Shares extends React.Component<ShareProps & RouteComponentProps<{ page: string }>> {
    render() {
        return <Switch>
            <Route path={'/share/:albumId'} render={() => {
                return <SR {...this.props} />
            }} />
            <Route>
                <Redirect to={'/'} />
            </Route>
        </Switch>
    }
})


// WEBPACK FOOTER //
// ./src/pages/Share.tsx